// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__TNY6z","title":"Settings_title__m1pIx"};